import React from 'react';
import styles from './styles.module.css';

const SocialLinks = () => (
  <ul className={styles.socialLinks}>
    <li>
      <a href="https://vk.com">vk</a>
    </li>
    <li>
      <a href="https://fb.com">fb</a>
    </li>
    <li>
      <a href="https://instagram.com">inst</a>
    </li>
  </ul>
);

export default SocialLinks;
